import { TableColumn } from '../types/analytics.types';

/**
 * Get tooltip text from column description field
 * @param column - The column configuration object
 * @returns Tooltip text or undefined if not found
 */
export const getColumnTooltip = (column: TableColumn): string | undefined => {
  return column.description;
};

/**
 * Check if a column has a tooltip available
 * @param column - The column configuration object
 * @returns True if tooltip exists
 */
export const hasColumnTooltip = (column: TableColumn): boolean => {
  return !!column.description;
};